import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';

type ActionType<V> = {
  type: string;
  value: V;
};

export type AppThunk<RootState, ReturnType = void> =
  ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const reduce = (<T, V>(initialState: T, actionMap: { [key: string]: string }) => (
  state = initialState,
  action: ActionType<V>,
): T => {
  if (actionMap[action.type]) {
    return {
      ...state,
      [actionMap[action.type]]: action.value,
    };
  }
  return {
    ...state,
  };
});

export const store = <V>(action: string, value: V): AppThunk<void> =>
  (dispatch: (ActionType) => void): void => {
    dispatch({
      type: action,
      value,
    });
  };
